module.exports = __webpack_public_path__ + "static/media/2.022d0bae.jpg";